import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.replace";
import _typeof from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moduleConfig from '@/components/BusinessComponent/moduleConfig';
import request from "@/utils/request";

// 查询模板通用接口
function _getQueryComponents(data) {
  return request({
    url: "/public/sqlTemplate/queryComponents?templateCode=" + data,
    method: "get",
    data: data
  });
}
export { _getQueryComponents as getQueryComponents };
export default {
  name: 'QueryTemplate',
  components: {},
  props: {
    templateId: {
      type: String,
      required: true,
      default: ""
    },
    showTempTitle: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      selects: [],
      checkedCities: [],
      checkAll: false,
      isIndeterminate: false,
      data: [],
      moduleConfig: moduleConfig,
      results: [],
      dowValue: null
    };
  },
  computed: {
    // 找到高级查询的数据
    advancedFilterData: function advancedFilterData() {
      var _this = this;
      return this.data.filter(function (item) {
        var type = !!_this.moduleConfig[item.componentId] && _this.moduleConfig[item.componentId].type;
        if (type !== "enum" && type !== "dow-enum" && item.isDefaultShow !== 0) {
          return item;
        }
      });
    },
    // 找到枚举的数据
    enumFilteData: function enumFilteData() {
      var _this2 = this;
      return this.data.filter(function (item) {
        var type = !!_this2.moduleConfig[item.componentId] && _this2.moduleConfig[item.componentId].type;
        if (type === "enum" && item.isDefaultShow !== 0) {
          return item;
        }
      });
    },
    // 找到下来枚举的数据
    otherFilteData: function otherFilteData() {
      var _this3 = this;
      return this.data.filter(function (item, index) {
        var type = !!_this3.moduleConfig[item.componentId] && _this3.moduleConfig[item.componentId].type;
        if (type === "dow-enum" && item.isDefaultShow !== 0) {
          return item;
        }
      });
    },
    // 隐藏的搜索条件
    hideFilteData: function hideFilteData() {
      return this.data.filter(function (item, index) {
        if (item.isDefaultShow === 0) {
          return item;
        }
      });
    }
  },
  watch: {
    checkedCities: {
      handler: function handler(newVal, oldval) {
        var _this4 = this;
        // 取消勾选添加进来的条件
        for (var i = this.advancedFilterData.length - 1; i >= 0; i--) {
          var item = this.advancedFilterData[i];
          if (item.isDefaultShow === 0 && !newVal.some(function (p) {
            return p === item.id;
          })) {
            this.resetVal(this.advancedFilterData[i]);
            this.advancedFilterData.splice(i, 1);
          }
        }
        for (var j = this.enumFilteData.length - 1; j >= 0; j--) {
          var enumItem = this.enumFilteData[j];
          if (enumItem.isDefaultShow === 0 && !newVal.some(function (p) {
            return p === enumItem.id;
          })) {
            this.resetVal(this.enumFilteData[j]);
            this.enumFilteData.splice(j, 1);
          }
        }
        for (var f = this.otherFilteData.length - 1; f >= 0; f--) {
          var otherItem = this.otherFilteData[f];
          if (otherItem.isDefaultShow === 0 && !newVal.some(function (p) {
            return p === otherItem.id;
          })) {
            this.resetVal(this.otherFilteData[f]);
            this.otherFilteData.splice(f, 1);
          }
        }
        newVal.forEach(function (id) {
          // 添加跟多条件
          _this4.data.forEach(function (dataItem) {
            if (id === dataItem.id) {
              var type = !!_this4.moduleConfig[dataItem.componentId] && _this4.moduleConfig[dataItem.componentId].type;
              if (type !== "enum" && type !== "dow-enum") {
                if (!_this4.advancedFilterData.some(function (p) {
                  return p.id === dataItem.id;
                })) {
                  _this4.advancedFilterData.push(dataItem);
                }
              }
              if (type === "enum") {
                if (!_this4.enumFilteData.some(function (p) {
                  return p.id === dataItem.id;
                })) {
                  _this4.enumFilteData.push(dataItem);
                }
              }
              if (type === "dow-enum") {
                if (!_this4.otherFilteData.some(function (p) {
                  return p.id === dataItem.id;
                })) {
                  _this4.otherFilteData.push(dataItem);
                }
              }
            }
          });
        });
      }
    },
    data: {
      // 动态监听筛选条件事件返回筛选的值出去
      handler: function handler(newVal, oldval) {
        var _this5 = this;
        this.results = [];
        this.data.forEach(function (item) {
          // if ((item.value && !Array.isArray(item.value)) || (Array.isArray(item.value) && item.value.length > 0)) {
          //   const result = {
          //     componentId: item.componentId,
          //     parameCode: item.keyName,
          //     parameName: item.lable,
          //     label: item.componentName,
          //     value: Array.isArray(item.value) ? item.value : (item.value ? item.value : "")
          //   }

          //   this.results.push(result)
          // }
          var result = {
            componentId: item.componentId,
            parameCode: item.keyName,
            parameName: item.lable,
            label: item.componentName,
            value: Array.isArray(item.value) ? item.value : item.value !== "" ? item.value : ""
          };
          _this5.results.push(result);
        });
        this.selects = [];
        this.results.forEach(function (item) {
          // 时间范围特殊处理
          if (item.componentId === 10) {
            item.value = Array.isArray(item.value) ? item.value : item.value === null ? ['', ''] : item.value.split(",");
            item.value.forEach(function (valItem, index) {
              _this5.selects.push({
                parameCode: index === 0 ? "@".concat(item.parameCode, "Start@") : "@".concat(item.parameCode, "End@"),
                parameName: index === 0 ? item.parameName : "".concat(item.parameName, "-1"),
                label: item.label,
                value: valItem
              });
            });
          } else if (Array.isArray(item.value)) {
            var vals = [];
            item.value.forEach(function (valItem) {
              vals.push(JSON.parse(valItem).value);
            });
            _this5.selects.push({
              parameCode: item.parameCode,
              parameName: item.parameName,
              label: item.label,
              value: vals
            });
          } else {
            _this5.selects.push({
              parameCode: item.parameCode,
              parameName: item.parameName,
              label: item.label,
              value: item.value
            });
          }
        });
        console.log(this.selects, this.data);
        this.$emit('callback', this.selects);
      },
      deep: true
    }
  },
  created: function created() {
    this.getQueryComponents(this.templateId);
  },
  methods: {
    // 处理输入变化，将换行符替换为逗号
    handleInputChange: function handleInputChange(value, item) {
      var _this6 = this;
      // 兼容处理：如果第一个参数是 item 对象（参数顺序可能反了）
      var actualValue = value;
      var actualItem = item;
      if (value && _typeof(value) === 'object' && value.componentName) {
        actualValue = item;
        actualItem = value;
      }

      // 将所有换行符（\n, \r, \r\n）替换为逗号
      if (actualValue && typeof actualValue === 'string') {
        var filteredValue = actualValue.replace(/[\r\n]+/g, ',');
        if (filteredValue !== actualValue) {
          // 使用 $nextTick 确保在下一个 DOM 更新周期中更新
          this.$nextTick(function () {
            _this6.$set(actualItem, 'value', filteredValue);
          });
        }
      }
    },
    // 取消勾选显示出来的查询条件情况当前查询条件所选的值
    resetVal: function resetVal(currItem) {
      if (currItem) {
        this.data.forEach(function (item) {
          if (item.keyName === currItem.keyName) {
            if (Array.isArray(item.value)) {
              item.value = [];
            } else {
              item.value = "";
            }
          }
        });
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.hideFilteData.map(function (item) {
        return item.id;
      }) : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.hideFilteData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.hideFilteData.length;
    },
    getQueryComponents: function () {
      var _getQueryComponents2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(templateId) {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _getQueryComponents(templateId);
            case 2:
              result = _context.sent;
              if (result.code === 200) {
                // 赋值默认值
                result.data.forEach(function (item) {
                  if (item.defaultValue !== "" || item.defaultValue.length > 0) {
                    item.value = item.defaultValue;
                  }
                });
                this.data = result.data;
              } else {
                this.$message({
                  type: "error",
                  message: result.msg
                });
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getQueryComponents(_x) {
        return _getQueryComponents2.apply(this, arguments);
      }
      return getQueryComponents;
    }(),
    rest: function rest() {
      var _this7 = this;
      this.data.forEach(function (item) {
        if (item.componentId === 10) {
          _this7.$set(item, 'value', ['', '']);
        } else {
          _this7.$set(item, 'value', "");
        }
      });
    },
    close: function close(currItem) {
      var _this8 = this;
      this.results.forEach(function (item, index) {
        if (item.label === currItem.label) {
          _this8.results.splice(index, 1);
        }
      });
      this.data.forEach(function (item) {
        if (item.componentName === currItem.label) {
          item.value = Array.isArray(item.value) ? [] : "";
        }
      });
    }
  }
};